// @flow
import { createSelector } from "reselect"
import type { List } from "immutable"
import type { InputSelector } from "reselect"

import type Flight from "common/records/Flight"
import { PART_TYPES } from "booking/scenes/ReservationForm/consts/reservationConsts"
import { currentBookingFlightsSelector } from "mmb/scenes/AccountBooking/components/Booking/services/selector"

// eslint-disable-next-line flowtype/generic-spacing
export const segmentsEligibleForAdditionalServicesSelector: InputSelector<
  any,
  *,
  List<Flight>,
> = createSelector(
  [
    state => state.booking.data.config.allowedToChange.additionalServices,
    currentBookingFlightsSelector,
  ],
  (allowedToChangeConfig, flights: List<Flight>) => {
    return flights.filter(
      flight =>
        flight.getHoursToDeparture() >= allowedToChangeConfig &&
        // * currently only flights are allowed
        flight.type === PART_TYPES.FLIGHT,
    )
  },
)

// eslint-disable-next-line flowtype/generic-spacing
export const segmentIdsEligibleForAdditionalServicesSelector: InputSelector<
  any,
  *,
  $ReadOnlyArray<string>,
> = createSelector(
  segmentsEligibleForAdditionalServicesSelector,
  (segments: List<Flight>) => segments.toArray().map(item => item.id),
)

export default segmentsEligibleForAdditionalServicesSelector
